import axios from 'axios';

export const axiosInstance = axios.create({baseURL: '/rest-api'});

export const getCancelTokenSource = () => {
  return axios.CancelToken.source();
};

export const isCancel = (error) => {
  return axios.isCancel(error);
};
